import React, {createContext } from 'react'
import { useToggle } from '../customHooks/useToggle'

interface ModalProviderProps {
    children: React.ReactNode
}

type ContextProps = {
    modal1: boolean,
    setModal1: () => void,
    modal2: boolean,
    setModal2: () => void,
    modal3: boolean,
    setModal3: () => void,
    modal4: boolean,
    setModal4: () => void,
}

export const ModalContext = createContext<Partial<ContextProps>>({})

export default function ModalProvider({ children }: ModalProviderProps) {
    
    const [ modal1, setModal1 ] = useToggle()
    const [ modal2, setModal2 ] = useToggle()
    const [ modal3, setModal3 ] = useToggle()
    const [ modal4, setModal4 ] = useToggle()

    return (
        <ModalContext.Provider
            value = {{
                modal1,
                setModal1,
                modal2,
                setModal2,
                modal3,
                setModal3,
                modal4,
                setModal4,
            }}
        >
            {children}
        </ModalContext.Provider>
    )
}